module.exports = __webpack_public_path__ + "static/img/ic-3.e856455.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/ic-3.svg
// module id = 1jQo
// module chunks = 1